import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ReplaceSelectTaxinvoiceComponent } from "./pages/replace/replace-select-taxinvoice/replace-select-taxinvoice.component";
import { ReplaceCheckdataTaxinvoiceComponent } from "./pages/replace/replace-checkdata-taxinvoice/replace-checkdata-taxinvoice.component";
import { ReplaceSavedataTaxinvoiceComponent } from "./pages/replace/replace-savedata-taxinvoice/replace-savedata-taxinvoice.component";
import { TaxInvoiceSaveComponent } from "./pages/tax-invoice/tax-invoice-save/tax-invoice-save.component";
import { TaxInvoiceSearchBuyProductComponent } from "./pages/tax-invoice/tax-invoice-search-buy-product/tax-invoice-search-buy-product.component";
import { TaxInvoiceSelectComponent } from "./pages/tax-invoice/tax-invoice-select/tax-invoice-select.component";
import { TaxInvoiceEditComponent } from "./pages/tax-invoice/tax-invoice-select/tax-invoice-edit/tax-invoice-edit.component";
import { CreditSelectTaxinvoiceComponent } from "./pages/credit-note/credit-select-taxinvoice/credit-select-taxinvoice.component";
import { CreditSaveTaxinvoiceComponent } from "./pages/credit-note/credit-save-taxinvoice/credit-save-taxinvoice.component";
import { CreditCheckTaxinvoiceComponent } from "./pages/credit-note/credit-check-taxinvoice/credit-check-taxinvoice.component";
import { ReportDocumentComponent } from "./pages/report/report-document/report-document.component";
import { ReportSendDocumentComponent } from "./pages/report/report-send-document/report-send-document.component";
import { ResendSelectTaxinvoiceComponent } from "./pages/resend/resend-select-taxinvoice/resend-select-taxinvoice.component";
import { ResendTaxinvoiceComponent } from "./pages/resend/resend-taxinvoice/resend-taxinvoice.component";
import { AuthGuard } from "./auth.guard";
import { TaxInvoiceComponent } from "./pages/tax-invoice/tax-invoice.component";
import { ReplaceComponent } from "./pages/replace/replace.component";
import { CreditNoteComponent } from "./pages/credit-note/credit-note.component";
import { ReportComponent } from "./pages/report/report.component";
import { ResendComponent } from "./pages/resend/resend.component";
import { TaxInvoiceSavedataComponent } from "./pages/tax-invoice/tax-invoice-select/tax-invoice-savedata/tax-invoice-savedata.component";
import { TaxInvoicePreviewComponent } from "./pages/tax-invoice/tax-invoice-preview/tax-invoice-preview.component";
import { ReplacePreviewComponent } from "./pages/replace/replace-preview/replace-preview.component";
import { CreditNotePreviewComponent } from "./pages/credit-note/credit-note-preview/credit-note-preview.component";
import { ReportDetailComponent } from "./pages/report/report-detail/report-detail.component";
import { LoginComponent } from "./pages/login/login.component";
import { CreditNoteTaxListComponent } from "./pages/credit-note/credit-note-tax-list/credit-note-tax-list.component";
import { ResendDetailComponent } from "./pages/resend/resend-detail/resend-detail.component";
import { CustomerSearchComponent } from "./pages/configuration/customer-search/customer-search.component";
import { SellerDataComponent } from './pages/configuration/seller-data/seller-data.component';
import { ConfigurationDataComponent } from './pages/configuration/configuration-data/configuration-data.component';
import { RoleManagementDataComponent } from './pages/configuration/role-management-data/role-management-data.component';
import { CustomerDetailComponent } from './pages/configuration/customer-detail/customer-detail.component';
import { SellerDetailComponent } from './pages/configuration/seller-detail/seller-detail.component';
import { ConfigurationDetailComponent } from './pages/configuration/configuration-detail/configuration-detail.component';
import { RoleManagementDetailComponent } from './pages/configuration/role-management-detail/role-management-detail.component';
import { CustomerAddComponent } from './pages/configuration/customer-add/customer-add.component';
import { SellerAddComponent } from './pages/configuration/seller-add/seller-add.component';
import { HomeComponent } from './pages/home/home.component';
import { CommonModule } from '@angular/common';
import { NoTaxinvoiceComponent } from './pages/no-taxinvoice/no-taxinvoice.component';
import { SelectNoTaxinvoiceComponent } from './pages/no-taxinvoice/select-no-taxinvoice/select-no-taxinvoice.component';
import { EditNoTaxinvoiceComponent } from './pages/no-taxinvoice/edit-no-taxinvoice/edit-no-taxinvoice.component';
import { AddNoTaxinvoiceComponent } from './pages/no-taxinvoice/add-no-taxinvoice/add-no-taxinvoice.component';
import { CheckNoTaxinvoiceComponent } from './pages/no-taxinvoice/check-no-taxinvoice/check-no-taxinvoice.component';
import { PreviewNoTaxinvoiceComponent } from './pages/no-taxinvoice/preview-no-taxinvoice/preview-no-taxinvoice.component';
import { NoCreditComponent } from './pages/credit-note/no-credit/no-credit.component';
import { reportEndDayComponent } from "./pages/report-end-day/report-end-day.component";
import { ExternalReportComponent } from "./pages/backoffice/external-report/external-report.component";
import { DeleteFulltaxComponent } from "./pages/backoffice/delete-fulltax/delete-fulltax.component";
import { LogEtaxComponent } from "./pages/backoffice/log-etax/log-etax.component";
import { DeleteFulltaxDetailComponent } from "./pages/backoffice/delete-fulltax-detail/delete-fulltax-detail.component";
import { LogEtaxDetailComponent } from "./pages/backoffice/log-etax-detail/log-etax-detail.component";
import { BackofficeComponent } from "./pages/backoffice/backoffice.component";
import { UnlockAbbComponent } from "./pages/backoffice/unlock-abb/unlock-abb.component";
import { UnlockAbbDetailComponent } from "./pages/backoffice/unlock-abb-detail/unlock-abb-detail.component";
import { ModalsaveNoTaxinvoiceComponent } from "./pages/no-taxinvoice/modalsave-no-taxinvoice/modalsave-no-taxinvoice.component";
import { ModalSaveDraftComponent } from "./pages/tax-invoice/modal-save-draft/modal-save-draft.component";
import { ModalSaveDraftNoTaxinvoiceComponent } from "./pages/no-taxinvoice/modal-save-draft-no-taxinvoice/modal-save-draft-no-taxinvoice.component";


const version_string = "alpha Version 0.0.2";

const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  { path: "login", component: LoginComponent },
  { path: "home", component: HomeComponent, canActivate: [AuthGuard] },
  { path: "replace", component: ReplaceComponent, canActivate: [AuthGuard] },
  {
    path: "replace-select-taxinvoice",
    component: ReplaceSelectTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "replace-checkdata-taxinvoice",
    component: ReplaceCheckdataTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "replace-savedata-taxinvoice",
    component: ReplaceSavedataTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "replace-preview",
    component: ReplacePreviewComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "tax-invoice",
    component: TaxInvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tax-invoice-save",
    component: TaxInvoiceSaveComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "modal-save-draft",
    component: ModalSaveDraftComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "modal-save-draft-no-taxinvoice",
    component: ModalSaveDraftNoTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tax-invoice-search-buy",
    component: TaxInvoiceSearchBuyProductComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tax-invoice-select",
    component: TaxInvoiceSelectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tax-invoice-edit",
    component: TaxInvoiceEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tax-invoice-savedata",
    component: TaxInvoiceSavedataComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tax-invoice-preview",
    component: TaxInvoicePreviewComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "credit-note",
    component: CreditNoteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "credit-select-taxinvoice",
    component: CreditSelectTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "credit-check-taxinvoice",
    component: CreditCheckTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "credit-save-taxinvoice",
    component: CreditSaveTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "credit-note-preview",
    component: CreditNotePreviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "credit-note-tax-list",
    component: CreditNoteTaxListComponent,
    canActivate: [AuthGuard],
  },

  { path: "report", component: ReportComponent, canActivate: [AuthGuard] },
  {
    path: "report-document",
    component: ReportDocumentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "report-send-document",
    component: ReportSendDocumentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "report-detail",
    component: ReportDetailComponent,
    canActivate: [AuthGuard],
  },

  { path: "resend", component: ResendComponent, canActivate: [AuthGuard] },
  {
    path: "resend-select-taxinvoice",
    component: ResendSelectTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "resend-taxinvoice",
    component: ResendTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "resend-detail",
    component: ResendDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "customer-search",
    component: CustomerSearchComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "seller-data",
    component: SellerDataComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "configuration-data",
    component: ConfigurationDataComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "role-management-data",
    component: RoleManagementDataComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "customer-detail",
    component: CustomerDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "customer-add",
    component: CustomerAddComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "seller-detail",
    component: SellerDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'seller-add',
    component: SellerAddComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "configuration-detail",
    component: ConfigurationDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "role-management-detail",
    component: RoleManagementDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "no-tax-invoice",
    component: NoTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "select-no-taxinvoice",
    component: SelectNoTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "edit-no-taxinvoice",
    component: EditNoTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-no-taxinvoice",
    component: AddNoTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "check-no-taxinvoice",
    component: CheckNoTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "preview-no-taxinvoice",
    component: PreviewNoTaxinvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "no-credit",
    component: NoCreditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "backoffice",
    component: BackofficeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "backoffice/external-report",
    component: ExternalReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "backoffice/delete-fulltax",
    component: DeleteFulltaxComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "backoffice/delete-fulltax-detail",
    component: DeleteFulltaxDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "backoffice/log-etax",
    component: LogEtaxComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "backoffice/log-etax-detail",
    component: LogEtaxDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "backoffice/unlock-abb",
    component: UnlockAbbComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "backoffice/unlock-abb-detail",
    component: UnlockAbbDetailComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "manual-header",
    loadChildren: () =>
      import("./pages/components/manual-header/manual-header.module").then(
        (m) => m.ManualHeaderPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "manual-replace",
    loadChildren: () =>
      import("./pages/components/manual-replace/manual-replace.module").then(
        (m) => m.ManualReplacePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "manual-taxinvoice",
    loadChildren: () =>
      import(
        "./pages/components/manual-taxinvoice/manual-taxinvoice.module"
      ).then((m) => m.ManualTaxinvoicePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "manual-taxinvoice-edit",
    // tslint:disable-next-line: max-line-length
    loadChildren: () =>
      import(
        "./pages/components/manual-taxinvoice-edit/manual-taxinvoice-edit.module"
      ).then((m) => m.ManualTaxinvoiceEditPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "manual-credit-note",
    loadChildren: () =>
      import(
        "./pages/components/manual-credit-note/manual-credit-note.module"
      ).then((m) => m.ManualCreditNotePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "manual-report",
    loadChildren:
      "./pages/components/manual-report/manual-report.module#ManualReportPageModule",
    canActivate: [AuthGuard],
  },
  {
    path: "inquiry",
    loadChildren: "./pages/inquiry/inquiry.module#InquiryPageModule",
  },
  {
    path: "manual-config",
    loadChildren: () =>
      import("./pages/components/manual-config/manual-config.module").then(
        (m) => m.ManualConfigPageModule
      ),
  },
  {
    path: "configuration",
    loadChildren: () =>
      import("./pages/configuration/configuration.module").then(
        (m) => m.ConfigurationPageModule
      ),
  },
  {
    path: 'manual-notaxinvoice',
    loadChildren: () => import('./pages/components/manual-notaxinvoice/manual-notaxinvoice.module').then( m => m.ManualNotaxinvoicePageModule)
  },
  { path: "report-end-day", component: reportEndDayComponent, canActivate: [AuthGuard] },
  {
    path: 'manual-backoffice',
    loadChildren: () => import('./pages/components/manual-backoffice/manual-backoffice.module').then( m => m.ManualBackofficePageModule),
    canActivate: [AuthGuard],
  },



  // {
  //   path: '**',
  //   redirectTo: 'login'
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
